import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthType, EMAIL_REGEX, USER_NAME} from '../../common/constants';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedValueService} from '../../services/shared-value.service';
import {FormGroup} from '@angular/forms';
import {RegisterPageValidator} from './register-page.validator';
import {GroupSetting} from '../../models/group-setting';
import {AuthenticationService} from '../../services/authentication.service';
import {GroupService} from '../../services/group.service';
import {NotifierService} from 'angular-notifier';
import {DomSanitizer} from '@angular/platform-browser';
import {Subscription} from 'rxjs/Rx';
import {Helper} from '../../common/helper';
import {RegisterSetting} from '../../models/register-setting';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  providers: [RegisterPageValidator],
  preserveWhitespaces: false
})
export class LoginPageComponent implements OnInit, OnDestroy {
  public groupSubscription: Subscription;
  public loading = false;
  public groups: GroupSetting[] = [];
  public _authType: any = AuthType.login;
  public authTypeConstant: typeof AuthType = AuthType;
  // login
  public _email = '';
  public username = '';
  public _password = '';
  public _showPassword = false;
  // public loginErrorMsg = {email: '', password: '', response: ''};
  public loginErrorMsg = {username: '', password: '', response: ''};
  // register
  public registerForm: FormGroup;
  public registerFormError: any;
  // forgot password
  public errorForgotPassword = '';
  public sendMailSuccess = '';
  public mailAddressForgot;
  // reset password
  public resetPassForm: FormGroup;
  public tokenResetPassword;
  public resetPassSuccess: any;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private sharedValueService: SharedValueService,
              private registerPageValidator: RegisterPageValidator,
              private authService: AuthenticationService,
              private groupService: GroupService,
              private notify: NotifierService,
              private sanitizer: DomSanitizer,
              private helper: Helper) { }

  ngOnInit() {
    this.registerForm = this.registerPageValidator.createForm(AuthType.register);
    this.resetPassForm = this.registerPageValidator.createForm(AuthType.reset_password);
    this.registerFormError = this.registerPageValidator.formError;
    this.registerPageValidator.getValidationMessages();
    // get groups
    this.helper._unsubsribe(this.groupSubscription);
    this.groupSubscription = this.groupService.getAllGroups().subscribe(gr => {
      this.groups = gr;
      this.registerForm.get('group_id').setValue(this.groups[0].id);
    });

    this.activatedRoute.params.subscribe((param: any) => {
      this.tokenResetPassword = param['token'];
      if (this.tokenResetPassword) {
        this._authType = AuthType.reset_password;
      }
    });
    this.activatedRoute.fragment
      .subscribe( fragment => {
        if (Object.values(this.authTypeConstant).includes(fragment)) {
          this._authType = fragment;
        }
      });
  }

  ngOnDestroy() {
    this.helper._unsubsribe(this.groupSubscription);
  }

  onClickLogin() {
    if (!this.loading) {
      this.loginErrorMsg.username = '';
      this.loginErrorMsg.password = '';
      this.loginErrorMsg.response = '';
      if (!this.username || !this._password) {
        this.loginErrorMsg.username = !this.username ? 'The user name field is required.' : '';
        this.loginErrorMsg.password = !this._password ? 'The password field is required.' : '';
        if (this.username && !USER_NAME.test(this.username)) {
          this.loginErrorMsg.username = 'The user name format is invalid.';
        }
        return;
      }
      this.loading = true;
      this.authService.login(this.username, this._password).subscribe(() => {
        this.loading = false;
        this.sharedValueService.fetchUserSession().subscribe(res => {
          this.router.navigate([this.getTransitUrl()]);
          this.authService.redirectUrl = null;
        }, err => {
          this.loginErrorMsg['response'] = 'Login Error';
        });
      }, error => {
        this.loading = false;
        if (error.error) {
        
          if (typeof error.error['message'] === 'string') {
            if (error.error['message'] == 'Thông tin đăng nhập không chính xác') {
              this.loginErrorMsg['response'] = 'Login information is incorrect';
            } else {
              this.loginErrorMsg['response'] = 'Account does not exist';
            }
          } else {
            for (const key in  error.error['message']) {
              if (this.loginErrorMsg.hasOwnProperty(key)) {
                this.loginErrorMsg[key] =  error.error['message'][key];
              }
            }
          }
        }
      });
    }
  }

  // goToRegisterForm() {
  //   this._email = '';
  //   this._password = '';
  //   window.location.hash = AuthType.register;
  //   this._authType = AuthType.register;
  //   for (const field in this.registerPageValidator.formError) {
  //     this.registerPageValidator.formError[field] = '';
  //     this.registerFormError[field] = '';
  //   }
  //   this.registerForm.get('group_id').setValue(this.groups.length > 0 ? this.groups[0].id : null);
  // }
  //
  // goToForgotPasswordForm() {
  //   this.mailAddressForgot = '';
  //   this._authType = AuthType.forgot_password;
  //   window.location.hash = AuthType.forgot_password;
  // }
  //
  //
  // backLoginForm(mail?: string, pass?: string) {
  //   this.resetPassSuccess = null;
  //   this.sendMailSuccess = '';
  //   this.loginErrorMsg.email = '';
  //   this.loginErrorMsg.password = '';
  //   this._email = mail || '';
  //   this._password = pass || '';
  //   this.loading = false;
  //   window.location.hash = AuthType.login;
  //   this._authType = AuthType.login;
  //   this.registerForm.reset();
  //   this.mailAddressForgot = '';
  // }

  // redirectToLoginPage(event) {
  //   if (event.target.tagName.toLowerCase() === 'a' && event.target.hasAttribute('routerLink')) {
  //     this.router.navigate([event.target.getAttribute('routerLink')]);
  //   }
  // }
  //
  // onChangeGroup(event: any) {
  //   this.registerForm.controls['group_id'].setValue(event);
  // }
  //
  // onClickRegister() {
  //   this.registerPageValidator.validateRegisterForm(this.registerForm);
  //   if (this.registerForm.valid) {
  //     this.loading = true;
  //     const model = Object.assign(new RegisterSetting(), this.registerForm.value);
  //     model.name = model.name.trim();
  //     this.authService.register(model).subscribe(res => {
  //       setTimeout(() => {
  //         this.loading = false;
  //       });
  //       this.notify.notify('success', 'Registration Successful! Please Login');
  //       setTimeout(() => {
  //         this.backLoginForm(this.registerForm.controls.email.value, this.registerForm.controls.password.value);
  //       }, 400);
  //     }, (error) => {
  //       setTimeout(() => {
  //         this.loading = false;
  //       });
  //       this.resetPassForm.reset('password');
  //       this.resetPassForm.reset('password_confirmation');
  //
  //       if (error.error) {
  //         if (typeof error.error['message'] === 'object') {
  //           for (const key in  error.error['message']) {
  //             if (this.registerFormError.hasOwnProperty(key)) {
  //               this.registerFormError[key] =  error.error['message'][key];
  //             }
  //           }
  //         } else if (typeof error.error['message'] === 'string') {
  //           this.notify.notify('error', error.error['message']);
  //         }
  //       } else {
  //         this.notify.notify('error', 'Error occurred!');
  //       }
  //     });
  //   }
  // }
  //
  // postForgotPassword() {
  //   this.errorForgotPassword = '';
  //   this.sendMailSuccess = '';
  //   if (!this.mailAddressForgot || this.mailAddressForgot && this.mailAddressForgot.trim() === '') {
  //     this.errorForgotPassword = 'Please enter your e-mail address';
  //   } else if (!EMAIL_REGEX.test(this.mailAddressForgot)) {
  //     this.errorForgotPassword = 'The form of the e-mail address is Incorrect.';
  //   } else {
  //     setTimeout(() => {
  //       this.loading = true;
  //     });
  //     this.authService.forgotPassword(this.mailAddressForgot).subscribe(res => {
  //       setTimeout(() => {
  //         this.loading = false;
  //       });
  //       this.sendMailSuccess = res.message;
  //     }, error => {
  //       setTimeout(() => {
  //         this.loading = false;
  //       });
  //       if (error.error) {
  //         this.errorForgotPassword =  error.error['message'];
  //       } else {
  //         this.notify.notify('error', 'Error occurred!');
  //       }
  //     });
  //   }
  // }
  //
  // onClickResetPassword() {
  //   this.resetPassSuccess = null;
  //   this.registerPageValidator.validateRegisterForm(this.resetPassForm);
  //   if (this.resetPassForm.valid) {
  //     this.resetPassForm.controls.token.setValue(this.tokenResetPassword);
  //     this.loading = true;
  //     this.authService.resetPassword(this.resetPassForm.value).subscribe(res => {
  //       setTimeout(() => {
  //         this.loading = false;
  //       });
  //       const html = '<p>Your password has been reset successfully!</p><p>Click' +
  //         '<a href="javascript:void(0)" routerLink="/login" style="color: #ff9600; text-decoration: underline">' +
  //         ' here </a> to return to the login page</p>';
  //       this.resetPassSuccess = this.sanitizer.bypassSecurityTrustHtml(html);
  //       this.resetPassForm.reset();
  //     }, (error) => {
  //       this.resetPassSuccess = null;
  //       setTimeout(() => {
  //         this.loading = false;
  //       });
  //       if (error.error) {
  //         if (typeof error.error['message'] === 'object') {
  //           for (const key in  error.error['message']) {
  //             if (this.registerFormError.hasOwnProperty(key)) {
  //               this.registerFormError[key] =  error.error['message'][key];
  //             }
  //           }
  //         } else if (typeof error.error['message'] === 'string') {
  //           this.notify.notify('error', error.error['message']);
  //         }
  //       } else {
  //         this.notify.notify('error', 'Error occurred!');
  //       }
  //     });
  //   }
  // }

  private getTransitUrl(): string {
    const redirectUrl = this.authService.redirectUrl;
    if (!redirectUrl || (redirectUrl === '/login')) {
      return '/';
    }
    return redirectUrl;
  }


}



// WEBPACK FOOTER //
// /app/src/app/pages/login-page/login-page.component.ts